import axios from "../../utils/axios";

/*
 * BI-680 : catalogue de fonctionnalites (definition) + liaison par environnement.
 * Catalogue : GET/POST /api/features, PUT/DELETE /api/features/{oid},
 *   GET /api/features/{oid}/environments (jamais de cle).
 * Liaison : /api/features/environment/{finessId}[/{linkOid}] ;
 *   key n'est envoyee qu'en ecriture (absente = inchangee), jamais renvoyee.
 */
const arr = (res) => (Array.isArray(res && res.data) ? res.data : []);

export const fetchFeatures = async () => {
  const [features, modules, repositories] = await Promise.all([
    axios.get("/api/features"),
    axios.get("/api/modules"),
    axios.get("/api/repositories"),
  ]);
  return {
    features: arr(features),
    modules: arr(modules),
    repositories: arr(repositories),
  };
};

export const createFeature = (payload) => axios.post("/api/features", payload);

export const updateFeature = (oid, payload) =>
  axios.put(`/api/features/${oid}`, payload);

export const deleteFeature = (oid) => axios.delete(`/api/features/${oid}`);

export const fetchFeatureEnvironments = async (oid) =>
  arr(await axios.get(`/api/features/${oid}/environments`));

export const fetchEnvironmentFeatures = async (finessId) =>
  arr(await axios.get(`/api/features/environment/${finessId}`));

export const linkFeature = (finessId, payload) =>
  axios.post(`/api/features/environment/${finessId}`, payload);

export const updateFeatureLink = (finessId, linkOid, payload) =>
  axios.put(`/api/features/environment/${finessId}/${linkOid}`, payload);

export const unlinkFeature = (finessId, linkOid) =>
  axios.delete(`/api/features/environment/${finessId}/${linkOid}`);
